import { WorkOrderPhotoModel } from './work.order.photo.model';
import { WorkOrderRecurrenceModel, WorkOrderWatcherModel } from '..';

export class WorkOrderEditModel {
    public id: number;
    public title: string;
    public description: string;
    public workOrderStatus: string;
    public workOrderPriority: string;
    public workOrderCategoryId: string;
    public workOrderCategoryName: string;
    public companyId: number;
    public facilityId: string;
    public unitId: string;
    public assignedToId: string;
    public assignedToGroupId: string;
    public createdAutomatically: boolean;
    public photos: Array<WorkOrderPhotoModel>;
    public dueDate: string;
    public watchersIds: string[];
    public status: number;
    public createdById: string;
    public isRecurring: boolean;
    public workOrderRecurrence: WorkOrderRecurrenceModel;
    public followUpAssigneeId: string;
    public followUpInstruction: string;
    public isDelinquent: boolean;
    public reminderInterval: number;
    public enableReadNotification:boolean;
    public openSubTaskCount: number;
    public agreeCloseAllSubTaskAutomatically: boolean;

    constructor() {
        this.workOrderStatus = '1';
        this.workOrderPriority = '';
        this.workOrderCategoryId = '';
        this.facilityId = '';
        this.unitId = '';
        this.assignedToId = '';
        this.isDelinquent = false;
        this.agreeCloseAllSubTaskAutomatically = false;
        this.photos = new Array<WorkOrderPhotoModel>();
    }
}
